const HIPAGES_URL_OLD = 'homeimprovementpages.com.au';

const ASSET_URL = `assets.${HIPAGES_URL_OLD}`;
const ASSET_URL_COMPLETE = `https://${ASSET_URL}`;

const MEDIACACHE_URL = `mediacache.${HIPAGES_URL_OLD}`;
const MEDIACACHE_URL_COMPLETE = `https://${MEDIACACHE_URL}`;

const TRADIES_URL = `tradies.${HIPAGES_URL_OLD}`;
const TRADIES_URL_COMPLETE = `https://${TRADIES_URL}`;

const S3_UPLOADS = 'hip-public-uploads.s3.amazonaws.com';
const S3_UPLOADS_COMPLETE = `https://${S3_UPLOADS}`;

export const ASSET_HUI_IMAGES_URL_BASE = `//${ASSET_URL}/images/hui/`;
export const HIPAGES_HOSTNAME = `hipages.com.au`;

export default {
  ASSET_URL,
  ASSET_URL_COMPLETE,
  ASSET_HUI_IMAGES_URL_BASE,
  HIPAGES_HOSTNAME,
  HIPAGES_URL_OLD,
  HIPAGES_URL: `https://hipages.com.au`,
  MEDIACACHE_URL,
  MEDIACACHE_URL_COMPLETE,
  TRADIES_URL,
  TRADIES_URL_COMPLETE,
  S3_UPLOADS,
  S3_UPLOADS_COMPLETE
};
